import styles from './HostServiceListLoadingDialog.module.css'
import { CircularProgress, Dialog } from "@mui/material"

interface HostServiceListLoadingDialogProps {
    open: boolean,
    onClose?: (event: any) => void
    onOk?: (event: any) => void
    container?: Element
}

export const HostServiceListLoadingDialog = (props: HostServiceListLoadingDialogProps): JSX.Element => {
    const {
        open,
        onClose,
        onOk,
        container,
    } = props

    return (
        <>
            <Dialog
                open={open}
                container={container}
            >
                <div className={styles.HostServiceListLoadingDialog__Content}>
                    <h1 className={styles.HostServiceListLoadingDialog__Heading1}>Finding competitors <br/> In Real Time <br/> Please Wait...</h1>
                    <div><CircularProgress size={40} /></div>
                </div>
         
            </Dialog>
        </>
    )
}